export default __webpack_public_path__ + "static/media/aboutImage2.d76d5bc0.png";